export const projectConfig = {
  name: 'Parento Quoting Tool',
  description: 'A modern quoting tool application for creating and managing quotes efficiently.'
}; 